import Loadable from 'react-loadable'
import LoadingIndicatorFull from './LoadingIndicatorFull.js'

const LoadableMoodPicker = Loadable({
  loader: () => import('./MoodPicker.js'),
  loading: LoadingIndicatorFull,
})

export default LoadableMoodPicker
